import { useEventDelegation } from '@/libs/events';
import { Controller } from '@hotwired/stimulus';

/* global $, toastr, I18n */
export default class extends Controller {
  connect() {
    this.$element = $(this.element);

    this.$element.on('submit', '#form-filtros', (e) => {
      this.#revisarChecksMarcados(e.target);
    });

    this.$element.on('submit', '#wrapper-formulario form', (e) => {
      if (this.$element.find('#wrapper-listado input:checked').length < 1) {
        toastr.error('Debe seleccionar algún elemento de la lista');
        e.preventDefault();
      }
    });

    this.eventDelegationChange = useEventDelegation(
      this.element,
      'input[name="documentos_filters[objeto_id][]"]',
      'change',
      (e) => {
        this.#revisarChecksMarcados(e.target);
      },
    );

    this.$element.on('change', '#formato', function onChange() {
      $.cookie('formato', $(this).val());
    });

    // Cuando cambia el listado revisamos los checks marcados
    const wrapperListado = document.getElementById('wrapper-formulario');
    this.listadoObserver = new MutationObserver(() => {
      this.#revisarChecksMarcados(null);
    });

    this.listadoObserver.observe(wrapperListado, { childList: true });
  }

  disconnect() {
    this.eventDelegationChange.remove();
    this.listadoObserver.disconnect();
  }

  #revisarChecksMarcados(inputMarcado) {
    const $form = this.$element.find('#form-generar');

    if (inputMarcado) {
      const $input = $(inputMarcado);
      if ($form.data('seleccion-unica') && $input.prop('checked')) {
        const check = $form.find('[name=documentos_filters\\[objeto_id\\]\\[\\]]:checked').not($input)[0];
        if (check) {
          check.checked = false;
        }
      }
    }

    const count = $('#wrapper-listado').find('input:checked').length;
    const txt = count > 0 ? count : 'Ninguno';
    this.$element.find('#label-seleccionados').text(`${I18n.t('Seleccionados')}: ${txt}`);
  }
}
